export default {
    name: 'Nimi',
    tel: 'Telefon',
    save: 'Salvesta',
    confirm: 'Kinnita',
    cancel: 'Tühista',
    delete: 'Kustuta',
    complete: 'Lõpeta',
    loading: 'Laadimine...',
    telEmpty: 'Palun sisesta telefoninumber',
    nameEmpty: 'Palun sisesta nimi',
    nameInvalid: 'Vigane nimi',
    confirmDelete: 'Kas olete kindel, et soovite kustutada?',
    telInvalid: 'Vigane telefoninumber',
    vanCalendar: {
        end: 'Lõpp',
        start: 'Algus',
        title: 'Kalender',
        startEnd: 'Algus/Lõpp',
        weekdays: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Valige mitte rohkem kui ${maxRange} päeva`,
    },
    vanCascader: {
        select: 'Vali',
    },
    vanContactCard: {
        addText: 'Lisa kontaktinfo',
    },
    vanContactList: {
        addText: 'Lisa uus kontakt',
    },
    vanPagination: {
        prev: 'Eelmine',
        next: 'Järgmine',
    },
    vanPullRefresh: {
        pulling: 'Värskendamiseks tõmmake...',
        loosing: 'Vabastage värskendamiseks...',
    },
    vanSubmitBar: {
        label: 'Kokku:',
    },
    vanCoupon: {
        unlimited: 'Piiramatu',
        discount: (discount) => `${discount * 10}% allahindlus`,
        condition: (condition) => `Vähemalt ${condition}`,
    },
    vanCouponCell: {
        title: 'Kupong',
        tips: 'Kuponge pole',
        count: (count) => `Teil on ${count} kupong${count !== 1 ? 'i' : ''}`,
    },
    vanCouponList: {
        empty: 'Kuponge pole',
        exchange: 'Vaheta',
        close: 'Sulge',
        enable: 'Saadaval',
        disabled: 'Pole saadaval',
        placeholder: 'Kupongi kood',
    },
    vanAddressEdit: {
        area: 'Piirkond',
        postal: 'Postiindeks',
        areaEmpty: 'Palun valige kättesaamise piirkond',
        addressEmpty: 'Aadress ei tohi olla tühi',
        postalEmpty: 'Vale postiindeks',
        defaultAddress: 'Määra vaikeaadressiks',
        telPlaceholder: 'Telefon',
        namePlaceholder: 'Nimi',
        areaPlaceholder: 'Piirkond',
    },
    vanAddressEditDetail: {
        label: 'Aadress',
        placeholder: 'Aadress',
    },
    vanAddressList: {
        add: 'Lisa uus aadress',
    },
};